import item from '../CollectionItems/muralForTheTerracePlazaHotel';

export default {
  location: 'new-york-city',
  filename: 'new-york-city-mondrian',
  title: item.name,
};
